import React, { useEffect, useState } from 'react';
import { YikiRoomCard } from '../components/yiki/YikiRoomCard';
import { BrandLogo } from '../components/brand/BrandLogo';
import { yikiService } from '../services/yikiService';
import { formatYikiPayoutRange } from '../utils/yikiUtils';

const POLL_MS = 3000;

export function YikiOverviewPage() {
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    const load = () => {
      yikiService.getOverview().then(setRooms).catch(() => {});
    };
    load();
    const timer = setInterval(load, POLL_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="space-y-6">
      <section className="rounded-2xl border border-red-100 bg-gradient-to-br from-white via-red-50/30 to-brand-gold-light/20 p-6 text-center shadow-sm">
        <BrandLogo size="lg" className="mx-auto mb-3" />
        <h2 className="text-2xl font-bold text-brand-red">หวยยี่กี Mungkorn</h2>
        <p className="mt-2 text-sm text-gray-600">
          เลือกห้องเพื่อแทง · 2 ตัวท้าย {formatYikiPayoutRange(50, 95)} · 3 ตัวตรง{' '}
          {formatYikiPayoutRange(450, 950)}
        </p>
      </section>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {rooms.map((room) => (
          <YikiRoomCard key={room.id} room={room} />
        ))}
      </div>
    </div>
  );
}
